import React, { useState } from 'react';
import { Box, Modal, TextField, Typography, Button } from '@mui/material';
import { COLOR_SUCCESS_1 } from 'src/utils/colors';

const PartnerPasswordModal = ({
  openPartnerPasswordModal,
  setOpenPartnerPasswordModal,
}: {
  openPartnerPasswordModal: boolean;
  setOpenPartnerPasswordModal: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const [password, setPassword] = useState<string>('');

  const handleSaveAdminPassword = (password: string) => {
    localStorage.setItem('AffiliatePartnerPassword', password);
    setOpenPartnerPasswordModal(false);
    window.location.reload();
  };

  return (
    <Modal open={openPartnerPasswordModal} onClose={() => setOpenPartnerPasswordModal(false)}>
      <Box
        sx={{
          width: '50vw',
          background: '#fff',
          position: 'absolute',
          top: '40%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          padding: '30px',
          borderRadius: 4,
        }}
      >
        <Typography variant="h5">Enter The Affiliate Partner Password:</Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
          <TextField
            id="outlined-basic"
            variant="outlined"
            label="Password"
            value={password}
            onChange={e => {
              setPassword(e.target.value);
            }}
            sx={{ width: '100%' }}
          />
          <Button
            sx={{
              backgroundColor: COLOR_SUCCESS_1,
              color: 'white',
              ':hover': { backgroundColor: COLOR_SUCCESS_1 },
            }}
            onClick={() => {
              handleSaveAdminPassword(password);
            }}
          >
            Save
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default PartnerPasswordModal;